const { SEARCH_SORT_OPTIONS } = require('utils/CatalogConstants');

const ALLOWD_FILTERS = [
    'currentPage',
    'pageSize',
    'ph',
    'pl',
    'ref',
    'sortBy',
    'ptype'
];

const validateQueryParams = function (param, value) {
    const numberRegEx = /^(0|[1-9]\d*)$/g;
    const priceRangeRegEx = /^(min|max|(0|[1-9]\d*))$/g;
    const regExObj = {
        ref: /^[A-Za-z (\-",)?&\[\]=\d]*$/g,
        node: /^cat[0-9]+$/g,
        pl: priceRangeRegEx,
        ph: priceRangeRegEx,
        currentPage: numberRegEx,
        pageSize: numberRegEx
    };
    let sanitizedQueryParam;
    if (ALLOWD_FILTERS.indexOf(param) !== -1) {
        if (param === 'ptype' && value === 'manual') {
            sanitizedQueryParam = `${param}=manual`;
        }
        if (param === 'sortBy') {
            if (SEARCH_SORT_OPTIONS.find(e => e.name === value)) {
                sanitizedQueryParam = `sortBy=${value}`;
            }
        }
        if (param === 'ref') {
            if (regExObj.ref.test(decodeURIComponent(value))) {
                sanitizedQueryParam = `ref=${value}`;
            }
        }
        if (param !== 'ptype' && param !== 'sortBy' && param !== 'ref') {
            if (regExObj[param].test(value)) {
                sanitizedQueryParam = `${param}=${value}`;
            }
        }
    }
    return sanitizedQueryParam;
};

module.exports = {
    validateQueryParams,
    ALLOWD_FILTERS
};
